import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "../../ApiClient";
import { GetState, SetState, Store, StoreData } from "../types";

import { initialize } from "./initialize";

export const resetIntegrations = (set: SetState<StoreData>, get: GetState<Store>) => async () => {
  const integrationId = get().integrationId;
  if (integrationId === undefined) {
    console.warn("Integration ID is undefined");
    return;
  }
  try {
    await apiClient.integrations.postIntegrationsIdReset(integrationId);
    await initialize(set, get)();
  } catch (error) {
    enqueueSnackbar(t("error.title"));
  }
};

/** Resets integration via API but keeps current method (stays on same page). */
export const restartCurrentMethod = (set: SetState<StoreData>, get: GetState<Store>) => async () => {
  const integrationId = get().integrationId;
  if (integrationId === undefined) {
    console.warn("Integration ID is undefined");
    return;
  }
  try {
    await apiClient.integrations.postIntegrationsIdReset(integrationId);
    await initialize(set, get)();
  } catch (error) {
    enqueueSnackbar(t("error.title"));
  }
};
